import { IField } from "../interfaces/inputs/IField";
import { Endpoints } from "../utils/Endpoints";

export const BankFields: IField[] = [
  { name: "name", type: "text", label: "Name", size: {lg: 6}, position: 1 },
  { name: "account", type: "text", label: "Account", size: {lg: 6}, position: 2 },
  { name: "currency", type: "select",dataSrc: Endpoints.currencies, dataType: "currencies",  label: "Currency", size: {lg: 6}, position: 3 },
  { name: "opbal", type: "number", label: "Opbal", size: {lg: 6}, position: 4 }
].sort((a: IField, b: IField) => a.position - b.position);